<app-ace-select id="sharedSearchId"
                name="shared"
                bindLabel="label"
                bindValue="value"
                [items]="SharedSearchOption | enumOptions"
                [placeholder]="placeholder()"
                [clearable]="true"
                [formControl]="selectControl"/>
